import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import { Field, ErrorMessage } from 'formik';
import { FormGroup, Label } from 'reactstrap';
import { getLeadStage as onGetLeadStages } from 'store/actions';
import SafeField from "helpers/SafeField";

const LeadStageOption = () => {
    const dispatch = useDispatch();
    const { leadstages } = useSelector(state => ({
        leadstages: state.AppoinmentObject.leadstages,
      }));
      useEffect(() => {
        dispatch(onGetLeadStages(localStorage.getItem('userId')));
    }, [dispatch, onGetLeadStages]);
  
    return (
      <FormGroup className="mb-3">
        <Label htmlFor="stageId" className='w-100'>Stage</Label>
        <SafeField as="select" name="stageId" className="form-control">
          <option value="">Select</option>
          {leadstages.map((option) => (
            <option key={option.id} value={option.id}>
              {option.leadStageTitle}
            </option>
          ))}
        </SafeField>
        <ErrorMessage name="stageId" component="div" className="invalid-feedback" />
      </FormGroup>
    );
  };  

export default LeadStageOption;
